import { GridColDef } from "../../../Unknown/DataGrid";
import { AppointmentColumnItemPatientCity, AppointmentRowItem } from "../types";

export type ColumnPatientCityTranslations = {
  columnPatientCity: string;
};

const getColumnPatientCity = (params: {
  columnItem: AppointmentColumnItemPatientCity;
  translations: ColumnPatientCityTranslations;
}): GridColDef<AppointmentRowItem, string | null> => {
  const { columnItem, translations } = params;
  const { field } = columnItem;
  return {
    field,
    disableColumnMenu: true,
    flex: 0.8,
    minWidth: 200,
    headerName: translations.columnPatientCity,
    valueGetter: ({ row }) => {
      return row.patient?.city || null;
    },
  };
};

export default getColumnPatientCity;
